import PaymentMethods from './PaymentMethods'
export * from './TPaymentMethodsStore'

export default PaymentMethods
